





















































































































































import { Component, Prop, PropSync, Vue } from 'vue-property-decorator';
import IconLibrary from '@/views/system/settings/menu/unit/iconLibrary.vue';
import { menuServe, processServe } from '@/api/installServer';
import { arrayToTree } from '@/util/arrayToTree';

@Component({
  components: { IconLibrary },
})
export default class AddUser extends Vue {
  // 父组件传递过来的控制编辑页面: 1：主页面 2：编辑页面 3：新增下级页面 4：新增页面
  @PropSync('showFlag', Number) showWhatFlag!: number;
  @Prop(String) row!: string; // 父组件传递过来的需要修改一行的数据
  private pName: any = ''; // 展示上级菜单中文
  private pStatus: any = false; // 展示上级菜单中文
  scrollbar = true;

  private treeDataStore: any = []; // 存储树形图list
  private organDialogVisible = false; // 是否展示上级菜单的dialog
  dialogTitle = ''; // 上级菜单的dialog 标题
  checkNode: any = {}; // 被选中的节点数据
  treeData: any[] = [
    {
      label: '一级 1',
      id: '1',
      children: [
        {
          label: '二级 1-1',
          id: '1-1',
          children: [
            {
              label: '三级 1-1-1',
              id: '1-1-1',
            },
          ],
        },
      ],
    },
  ];
  predefineColors: any = ['#1677FF', '#38ac72', '#ffd913', '#ff8b13'];
  // dialog 中树形图的属性
  defaultProps: object = {
    children: 'children',
    label: 'label',
  };
  // 表单数据
  private formData: any = {
    base: false,
    breadCrumb: false,
    componentName: '',
    componentPath: '',
    display: true,
    icon: '',
    id: '',
    mode: '',
    name: '',
    orderNum: 0,
    perms: '',
    pid: '',
    routeUrl: '',
    type: 0,
    url: '',
    color: '#1677FF',
  };
  // 表单验证规则
  formRules: object = {
    type: [{ required: true, message: '必填信息', trigger: 'blur' }], // 菜单类型验证规则
    mode: [{ required: true, message: '必填信息', trigger: 'blur' }], // 归属模块验证规则
  };

  private modeOptions: any = [
    {
      value: 'pc',
      label: 'pc',
    },
    {
      value: 'app',
      label: 'app',
    },
  ];

  groupData: any = [];

  created() {
    this.getData();
    this.getFlow();
  }

  mounted() {
    this.hasScrollbar();
  }

  hasScrollbar() {
    const dom: any = document.getElementById('main_box');
    this.scrollbar = dom.scrollHeight > dom.clientHeight || dom.offsetHeight > dom.clientHeight;
  }

  getFlow() {
    processServe
      .getProcessData({})
      .then((res: any) => {
        // this.groupData = res.data;
        this.getFrom(res.data);
      })
      .catch((e: any) => {});
  }

  getFrom(groupData: any) {
    processServe
      .getFlowFormData({})
      .then((res: any) => {
        const data = res.data;
        groupData.forEach((group: any, index: any) => {
          groupData[index].options = [];
          data.forEach((form: any) => {
            if (form.groupId === group.id) {
              groupData[index].options.push(form);
            }
          });
        });

        // data.forEach((form: any) => {
        //   if (form.groupId === '') {
        //     this.otherGroupObj.formList.push(form);
        //   }
        // });
        this.groupData = groupData;
        console.log(this.groupData);
      })
      .catch((e: any) => {});
  }

  getData() {
    this.getMenuListData();
    // 1：主页组件 2：编辑 3：新增下级 4：新增
    if (this.showWhatFlag === 2) {
      // 先获取自身空间数据：name pid id sort enabled
      this.getSingleMenuListData(this.row);
    }
    if (this.showWhatFlag === 3) {
      // 获取到上级空间的 id 和上空间的 name
      this.getSingleMenuListDataAdd(this.row);
    }
    if (this.showWhatFlag === 4) {
    }
  }

  /**
         @description: 打开图标库
         @author: cxf
         @update: cxf 2021/5/20 11:02
         **/
  private openIconLibrary(data: any) {
    const iconLibary: any = 'iconLibary';
    const iconComponent: any = this.$refs[iconLibary];
    iconComponent.showDialog(data);
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 打开 上级菜单 dialog
   * @param1 name: dialog 弹框名称。
   * @param2 data: 菜单管理的内容
   * @returns 暂无
   */
  openOrganDialog(name: string, data?: any): void {
    this.dialogTitle = name; // dialog 标题
    this.checkNode.id = data.id ? data.id : ''; // 打开归属机构的dialog 让选中节点是data;
    this.organDialogVisible = true;
    this.$nextTick(() => {
      (this.$refs.searchOrganRef as any).focus();
      // 打开被选中的树
      this.openCheckedTree(this.treeData, data);
      // 打开一层目录
      this.treeData.forEach(item => {
        (this.$refs.dialogTreeRef as any).getNode(item.id).expanded = true;
      });
    });
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 点击上级菜单 input 触发事件，打开被选中的树节点。
   * @param1 tree: 树节点对象
   * @param2 name: 用于进行判断的名称
   * @returns 返回值描述
   */
  openCheckedTree(tree: any, data?: any) {
    tree.forEach((item: any) => {
      if (item.id === data.pid) {
        (this.$refs.dialogTreeRef as any).getNode(item.id).isCurrent = true;
        (this.$refs.dialogTreeRef as any).getNode(item.id).parent.expanded = true;
        (this.$refs.dialogTreeRef as any).getNode(item.id).expanded = true;
      } else if (item.children) {
        this.openCheckedTree(item.children, data);
      }
    });
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 每次点击树节点都会触发的事件，获得当前点击的id
   * @param1 data: 被点击的节点数据对象
   * @returns 暂无
   */
  handleNodeClick(data?: any) {
    // 取消被选中的 树节点。
    (this.$refs.dialogTreeRef as any).store._getAllNodes().forEach((item: any, i: number) => {
      if (item.data !== data) {
        (this.$refs.dialogTreeRef as any).getNode(item.data.id).isCurrent = false;
      }
    });
    this.checkNode = data; // 选中的节点数据
  }

  private formType(data: any) {
    switch (data) {
      case 2:
        // this.formData.icon = '';
        // this.formData.fontColor = '';
        // this.formData.tabTitle = '';
        // this.formData.display = true;
        // this.formData.perms = '';
    }
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 保存并提交编辑、新增
   * @param1 暂无
   * @returns 暂无
   */
  save(): void {
    const formComponent: any = this.$refs.form;
    formComponent.validate((valid: any) => {
      if (!valid) {
        return;
      }
      switch (this.showWhatFlag) {
        case 3:
          this.addFunctionData();
          break;
        case 2:
          this.editFunctionData();
          break;
        case 4:
          this.headAddFunctionData();
          break;
      }
    });
  }

  /**
   * 【接口】行内新增功能
   */
  private async addFunctionData() {
    if (this.formData.type === 3) {
      this.formData.url = '/flowWorkCustom/' + this.formData.flowFormId;
    }
    console.log(this.formData);
    menuServe
      .addMenuData({
        base: this.formData.base,
        breadCrumb: this.formData.breadCrumb,
        componentName: this.formData.componentName,
        componentPath: this.formData.componentPath,
        // display: true,
        display: this.formData.type === 2 ? false : this.formData.display,
        icon: this.formData.icon,
        id: '',
        mode: this.formData.mode,
        name: this.formData.name,
        orderNum: this.formData.orderNum,
        perms: this.formData.perms,
        pid: this.formData.pid,
        routeUrl: this.formData.routeUrl,
        type: this.formData.type === 3 ? 1 : this.formData.type,
        url: this.formData.url,
        flowFormId: this.formData.flowFormId,
        color: this.formData.color,
      })
      .then((res: any) => {
        if (res.code === '200') {
          this.$message.success('添加成功');
          this.close(); // 返回到父级页面
        }
      })
      .catch(() => {
        this.$message.error('添加失败,请稍后重试!');
      });
  }

  /**
   * 【接口】新增功能
   */
  private async headAddFunctionData() {
    const form = this.formData;
    if (this.formData.type === 3) {
      form.url = '/flowWorkCustom/' + this.formData.flowFormId;
      form.type = 1;
    }
    menuServe
      .addMenuData(form)
      .then((res: any) => {
        if (res.code === '200') {
          this.$message.success('添加成功');
          this.close(); // 返回到父级页面
        }
      })
      .catch(() => {
        this.$message.error('添加失败,请稍后重试!');
      });
  }

  /**
   * 【接口】编辑功能
   */
  private async editFunctionData() {
    const form = this.formData;
    // form.display = false;
    console.log(this.formData);
    if (this.formData.type === 3) {
      form.url = '/flowWorkCustom/' + this.formData.flowFormId;
      form.type = 1;
    }
    menuServe
      .editMenuData(form)
      .then((res: any) => {
        if (res.code === '200') {
          this.$message.success('保存成功');
          this.close(); // 返回到父级页面
        }
      })
      .catch(() => {
        this.$message.error('保存失败,请稍后重试!');
      });
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 点击关闭按钮，返回上一级.
   * @param1 暂无
   * @returns 暂无
   */
  close(): void {
    this.showWhatFlag = 1;
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 点击关闭按钮，返回上一级.
   * @param1 暂无
   * @returns 暂无
   */
  closeOrganDialog(): void {
    this.formData.info = '';
    this.checkNode = {}; // 将选中的节点数据清空
    this.organDialogVisible = false; // 关闭归属机构的 dialog
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 点击确定按钮，保存数据并返回上一级.
   * @param1 暂无
   * @returns 暂无
   */
  submitOrgan(): void {
    // if (this.formData.id === this.checkNode.id) {
    //   this.$message.warning('请不要自己套自己');
    //   return;
    // } else {
    this.formData.pid = this.checkNode.id;
    this.pName = this.checkNode.name;
    this.organDialogVisible = false; // 关闭归属机构的 dialog
    // }
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 点击清除按钮，回到最初状态.
   * @param1 暂无
   * @returns 暂无
   */
  clearOrgan(): void {
    this.getMenuListData();
    this.getSingleMenuListData(this.formData.id);
  }

  /**
   * @desc 通过主键查询单条数据
   * @param1 暂无
   * @returns 暂无
   */
  private getSingleMenuListData(id: any) {
    // 通过主键查询单条数据
    menuServe
      .getSingleMenuData(id)
      .then((res: any) => {
        this.formData = res.data;
        if (res.data.type === 1 && res.data.flowFormId) {
          this.formData.type = 3;
        }
        setTimeout(() => {
          this.pName = this.getTreeNodeName(res.data.pid);
        }, 50);
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  private getSingleMenuListDataAdd(id: any) {
    // 通过主键查询单条数据
    menuServe
      .getSingleMenuData(id)
      .then((res: any) => {
        this.formData.pid = res.data.id;
        console.log(this.formData);
        if (res.data.type === 1 && res.data.flowFormId) {
          this.formData.type = 3;
        }
        setTimeout(() => {
          this.pName = this.getTreeNodeName(res.data.id);
        }, 50);
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  private getTreeNodeName(id: any) {
    if (!id) {
      return null;
    }
    for (let i = 0, len = this.treeDataStore.length; i < len; i++) {
      const item = this.treeDataStore[i];
      if (item.id == id) {
        return item.name;
      }
    }
    return null;
  }

  /**
   * @desc 分页获取所有数据
   * @param1 暂无
   * @returns 暂无
   */
  getMenuListData() {
    // 发起接口请求，获取分页数据
    menuServe
      .sysMenuList({})
      .then((res: any) => {
        this.treeData = arrayToTree(res.data);
        this.treeDataStore = res.data;
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  /**
         @description: 接受子组件传回的图标信息
         @author: cxf
         @update: cxf 2021/5/20 11:03
         **/
  private handleMenuIconResponse(icon: any) {
    this.formData.icon = icon.className;
    this.$forceUpdate();
  }
}
